import { useState, useEffect } from "react";
import { Select } from "@mantine/core";
import { Modal } from "@mantine/core";
import { withTranslation } from "react-i18next";
import InputField from "../../../components/inputField";
import Button from "../../../components/Button";
import { backendUrl } from "../../../constants";
import { showNotification } from "@mantine/notifications";
import { useForm } from "@mantine/form";

const NewEducation = ({
  opened,
  setOpened,
  setRefetch,
  editId,
  setEditId,
  editData,
  isEdit,
  setIsEdit,
}) => {
  let createdBy = JSON.parse(localStorage.getItem("userData"));
  const [privacyLevels, setPrivacyLevels] = useState([]);
  const [states, setStates] = useState([]);
  const [schoolType, setSchoolType] = useState([]);
  const [schoolName, setSchoolName] = useState([]);
  const [major, setMajor] = useState([]);
  const [minor, setMinor] = useState([]);
  const [degree, setDegree] = useState([]);

  useEffect(() => {
    if (editId && editData) {
      form.setFieldValue("GPA", editData?.GPA);
      form.setFieldValue("summary", editData?.summary);
      form.setFieldValue("privacyLevel", editData?.privacyLevel?._id);
      form.setFieldValue("state", editData?.state?._id);
      form.setFieldValue("school", editData?.school?._id);
      form.setFieldValue("schoolType", editData?.schoolType?._id);
      form.setFieldValue("major", editData?.major?._id);
      form.setFieldValue("minor", editData?.minor?._id);
      form.setFieldValue("degree", editData?.degree?._id);
    }
  }, [editId, editData]);

  //privacy Levels
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/privacyLevel`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setPrivacyLevels((p) => [...p, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //state
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/state`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setStates((st) => [...st, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //school type
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/schoolType`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setSchoolType((st) => [...st, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //school name
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/school`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setSchoolName((st) => [...st, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);
  //major
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}major/listMajor`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.majorName };
          setMajor((st) => [...st, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //minor
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/minor`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = {
            value: obj._id,
            label: obj.lookupName === undefined ? "N/A" : obj.lookupName,
          };
          setMinor((st) => [...st, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //degree
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}degree/listDegree`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.degreeName };
          setDegree((st) => [...st, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      privacyLevel: "",
      state: "",
      schoolType: "",
      school: "",
      major: "",
      minor: "",
      degree: "",
      summary: "",
      GPA: "",
    },

    validate: {
      privacyLevel: (value) =>
        value?.length < 1 ? "Please Select Privacy" : null,
      state: (value) => (value?.length < 1 ? "Please Select State" : null),
      schoolType: (value) =>
        value?.length < 1 ? "Please Select School Type" : null,
      school: (value) => (value?.length < 1 ? "Please Select Schol" : null),
      major: (value) => (value?.length < 1 ? "Please Select Major" : null),
      minor: (value) => (value?.length < 1 ? "Please Select Minor" : null),
      degree: (value) => (value?.length < 1 ? "Please Select Degree" : null),
    },
  });

  const handleAddEducation = async (values) => {
    values.userId = createdBy.id;
    if (editId) {
      values.educationId = editId;
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(values),
      };
      await fetch(`${backendUrl}user/editJobSeekerEducation`, options)
        .then((response) => response.json())
        .then((response) => {
          showNotification({
            message: "Updated Successfully",
            color: "green",
          });
          handleClose();
          setRefetch((v) => !v);
        })
        .catch((err) => console.error(err));
    } else {
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(values),
      };
      await fetch(`${backendUrl}user/saveJobSeekerEducation`, options)
        .then((response) => response.json())
        .then((response) => {
          showNotification({
            message: "New Educated Added.",
            color: "green",
          });
          handleClose();
          setRefetch((v) => !v);
        })
        .catch((err) => console.error(err));
    }
  };

  const handleClose = () => {
    setEditId("");
    setOpened(false);
    form.reset();
    setIsEdit(false);
  };

  return (
    <>
      <Modal
        styles={{
          title: {
            width: "100%",
            textAlign: "center",
            paddingLeft: "10px",
          },
        }}
        opened={opened}
        centered
        onClose={handleClose}
        title={isEdit ? "Edit Education" : "Add New Education"}
      >
        <form onSubmit={form.onSubmit((values) => handleAddEducation(values))}>
          <div style={{ marginLeft: "auto" }} className="col-md-4">
            <p style={{ margin: "0px", fontWeight: "500" }}>Privacy</p>
            <Select
              placeholder="Privacy Level"
              data={privacyLevels}
              searchable
              {...form.getInputProps("privacyLevel")}
            />
          </div>
          <p style={{ margin: "0px", fontWeight: "500" }}>State</p>
          <Select
            placeholder="State"
            data={states}
            searchable
            maxDropdownHeight={400}
            {...form.getInputProps("state")}
          />
          <p style={{ margin: "0px", fontWeight: "500" }}>Type</p>
          <Select
            placeholder="Type"
            data={schoolType}
            searchable
            {...form.getInputProps("schoolType")}
            maxDropdownHeight={400}
          />
          <p style={{ margin: "0px", fontWeight: "500" }}>School</p>

          <Select
            placeholder="School"
            data={schoolName}
            searchable
            {...form.getInputProps("school")}
            maxDropdownHeight={400}
          />
          <p style={{ margin: "0px", fontWeight: "500" }}>Major</p>

          <Select
            placeholder="Major"
            data={major}
            {...form.getInputProps("major")}
            searchable
            maxDropdownHeight={400}
          />
          <p style={{ margin: "0px", fontWeight: "500" }}>Minor</p>
          <Select
            placeholder="Minor"
            data={minor}
            searchable
            {...form.getInputProps("minor")}
            maxDropdownHeight={400}
          />
          <p style={{ margin: "0px", fontWeight: "500" }}>Degree</p>
          <Select
            placeholder="Degree"
            data={degree}
            searchable
            maxDropdownHeight={400}
            {...form.getInputProps("degree")}
          />
          <p style={{ margin: "0px", fontWeight: "500" }}>Summary</p>
          <InputField
            placeholder="Summary"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            {...form.getInputProps("summary")}
          />
          <p style={{ margin: "0px", paddingBottom: "0px", fontWeight: "500" }}>
            GPA
          </p>
          <InputField
            placeholder="G.P.A"
            type="number"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            {...form.getInputProps("GPA")}
          />
          <div className="d-flex justify-content-end gap-2 mt-1">
            <Button title="Cancel" onClick={handleClose} />
            <Button
              title={editId ? "Edit Education" : "Add Education"}
              primary={true}
              type="submit"
            />
          </div>
        </form>
      </Modal>
    </>
  );
};
export default withTranslation()(NewEducation);
